var map = {
	"./22-06-43.png": 7555,
	"./JamaisSatchel.png": 9967,
	"./Limerence.png": 1864,
	"./MACKER.png": 7325,
	"./SonicFlowers.png": 2184,
	"./XMLtools.png": 3080,
	"./minesweeper.png": 1396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3102;